<button
  class="btn project-instructions__copy-btn"
  #tooltip="ngbTooltip"
  ngbTooltip="Copied to clipboard"
  placement="left"
  triggers="manual"
  (click)="copyText(tooltip)"
>
  Copy
</button>
